import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type Locale = 'zh-CN' | 'zh-TW' | 'en-US'

interface I18nState {
  locale: Locale
}

interface I18nActions {
  setLocale(locale: Locale): void
}

const useI18nStore = create<I18nState & I18nActions>()(
  persist(
    (set) => ({
      locale: 'zh-TW',
      setLocale: (locale) => set({ locale }),
    }),
    { name: 'i18n-storage' }
  )
)

export default useI18nStore
